<template>
	<m-main-layout>
		fds
	</m-main-layout>
</template>

<script>
export default {
	name: "detail",
	data() {
		return {
			id:''
		}
	},
	created() {
		this.id = this.$route.query.id ? this.$route.query.id : '';
	},
	mounted() {
		this.getDetail();
	},
	methods: {
		getDetail(){
			let _this = this;
			
			this.$http.httpPost({
				url:'/UserCompany/detail',
				datas:{id:this.id},
				success(res){
					console.log(res);
				}
			})
		}
	}
}
</script>
